/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboGroupRequestSchema } from "./calculateDiscountComboGroupRequestSchema.ts";

export const calculateDiscountDetailRequestSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	groups: z.array(calculateDiscountComboGroupRequestSchema),
	front_item_id: z.uuid().nullish(),
});
